import { cn } from '@shadcn/lib/utils';
import { MASKED_TEXT_CLASS } from 'analytics';
import { SuggestionMarkBase } from 'utils/noteDocument';

const SUGGESTION_CHIP_CLASS = cn(
  'mix-blend-multiply bg-vantis-pastelblue py-px text-vantis-violet shadow-[1.5px_0_0_0_var(--vantis-pastelblue),-1.5px_0_0_0_var(--vantis-pastelblue)]',
  MASKED_TEXT_CLASS
);

export const SuggestionMark = SuggestionMarkBase.configure({
  HTMLAttributes: { class: SUGGESTION_CHIP_CLASS, 'data-ph-no-autocapture': '' },
});
